import { InjectionToken } from '@angular/core';
import { MessagingPort } from './messaging.port';

export const MESSAGING_PORT = new InjectionToken<MessagingPort>('MESSAGING_PORT');
